/**
 * Smooth Scroll
 */

smoothScroll.init();
